import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";
import styles from "./PromotionItem.scss";
import classnames from "classnames";
import { Overlay } from "react-overlays";
import styled from "styled-components";
import Icon from "./Icon";
import PromotionDescription from "./PromotionDescription";
import { renderHTML } from "../../utils/misc";
import getSymbolFromCurrency from "currency-symbol-map";
import { white } from "../../theme/variables";

// Promo container is white by default, then hovered or activated the "brand color" is used
// When hovered both the promo text and the icon use the inverseColor
const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 10px;
  background-color: ${props => (props.active ? props.textColor : "fff")};
  color: ${props => (props.active ? props.inverseTextColor : "#222222")};
  &:hover {
    background-color: ${props => props.textColor};
    color: ${props => props.inverseTextColor};
    i,
    .wbkv9-PromotionItem-discountValue {
      color: ${props => props.inverseTextColor};
    }
  }
  & .wbkv9-PromotionItem-title {
    word-break: break-word;
  }
`;
// Icons and prices use the "brand color", when the promo is active they switch to the inverse
const PromoGraphic = styled.div`
  margin-right: 10px;
  flex: 0 0 50px;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  color: ${props => (props.active ? props.inverseTextColor : props.textColor)};
`;

const Container = styled.div``;
const ToolTip = props => {
  const { children, toolTipStyle, positionTooltip } = props;
  const isValid = val => val !== undefined && val !== null; //eslint-disable-line
  const overlayStyle = {
    marginTop: (isValid(toolTipStyle.marginTop) && `${toolTipStyle.marginTop}px`) || "auto",
  };
  const arrowStyle = {
    marginTop:
      (isValid(toolTipStyle.toolTipMarginTop) && `${toolTipStyle.toolTipMarginTop}px`) || "auto",
  };
  return (
    <div className={classnames("wbkv9-PromotionTooltip", styles.toolTip)}>
      <div
        style={arrowStyle}
        className={classnames("wbkv9-PromotionTooltip-toolTipArrow", styles.toolTipArrow)}
      />
      <div
        style={overlayStyle}
        ref={positionTooltip}
        className={classnames("wbkv9-PromotionTooltip-toolTipOverlay", styles.toolTipOverlay)}>
        <div className={classnames("wbkv9-PromotionTooltip-toolTipContent", styles.toolTipContent)}>
          {children}
        </div>
      </div>
    </div>
  );
};

//This is here only so react-overlay works with its refs properly.
class StatefulToolTip extends React.PureComponent {
  render() {
    return <ToolTip {...this.props} />;
  }
}

//TODO: Correct proptypes
// ToolTip.propTypes = {
//   children: PropTypes.object.isRequired,
//   toolTipStyle: PropTypes.object.isRequired,
//   positionTooltip: PropTypes.object.isRequired,
// };

const showDiscountReduction = promotion =>
  Boolean(
    promotion.get("reduction") &&
      !promotion.get("icon") &&
      promotion.get("reduction") !== 0 &&
      promotion.get("discountedNights") <= 0 &&
      promotion.get("minStayForDiscountedNights") <= 0
  );

const showDiscountPeriodicity = promotion =>
  Boolean(promotion.get("discountedNights") > 0 && promotion.get("minStayForDiscountedNights") > 0);

const Reduction = ({ promotion, currency, textColor, reductionClass }) => (
  <Container
    textColor={textColor}
    className={classnames("wbkv9-PromotionItem-discountValue", styles.discountValue)}>
    {promotion.get("percentage") && (
      <div className={classnames("wbkv9-PromotionItem-reduction", reductionClass)}>
        <FormattedNumber value={Math.ceil(promotion.get("reduction"))} />
        <span className={styles.percentageSign}>%</span>
      </div>
    )}
    {!promotion.get("percentage") && (
      <div className={classnames("wbkv9-PromotionItem-reduction", reductionClass)}>
        <FormattedNumber value={Math.ceil(promotion.get("reduction"))} />
        <span className={styles.currency}>{getSymbolFromCurrency(currency)}</span>
      </div>
    )}
  </Container>
);

const Periodicity = ({ promotion, textColor, reductionClass }) => {
  const discountedNights = promotion.get("discountedNights");
  const minStayForDiscountedNights = promotion.get("minStayForDiscountedNights");
  return (
    <Container
      textColor={textColor}
      className={classnames("wbkv9-PromotionItem-discountValue", styles.discountValue)}>
      <div className={classnames("wbkv9-PromotionItem-reduction", reductionClass)}>
        {`${minStayForDiscountedNights}x${minStayForDiscountedNights - discountedNights}`}
      </div>
    </Container>
  );
};
export default class PromotionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      active: false,
      placement: "left",
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle({ event }) {
    let toolTipStyle = {};
    if (event && event.target) {
      const elem = this.domElem;
      const promotionPosition = elem.getBoundingClientRect();
      const promotionListTopPosition = this.props.toolTipOffset();
      const promotionListScrollTop = this.props.scrollTop();
      const tooltipArrowPosition = elem.offsetHeight / 2 + 25;
      toolTipStyle = {
        toolTipOverlayTop: promotionPosition.top - promotionListTopPosition,
        toolTipArrowTop: promotionPosition.top - promotionListTopPosition + tooltipArrowPosition,
        marginTop: -(promotionListScrollTop + elem.offsetHeight + 20),
        toolTipMarginTop: -(promotionListScrollTop + tooltipArrowPosition - 15),
        position: "absolute",
      };
    }
    if (!this.state.show) {
      this.props.changeRemoved();
    }
    return this.setState({
      show: !this.state.show,
      active: !this.state.show,
      toolTipStyle,
    });
  }

  render() {
    const { promotion, currency, id, inverseTextColor, textColor } = this.props;
    const refString = `wbkv9-PromotionItem-target-${id}`;
    const showReduction = showDiscountReduction(promotion);
    const showPeriodicity = showDiscountPeriodicity(promotion);
    const reductionClass = inverseTextColor !== white ? styles.reductionBlack : styles.reduction;

    return (
      <div
        className={classnames(
          "wbkv9-PromotionItem",
          styles.promotionItem,
          this.state.active && styles.active,
          this.state.active && "wbkv9-PromotionItem--active"
        )}
        ref={elem => {
          this.domElem = elem;
        }}
        id={refString}
        onClick={event => this.toggle({ event })}>
        <InnerContainer
          textColor={textColor}
          inverseTextColor={inverseTextColor}
          active={this.state.active}>
          <PromoGraphic
            active={this.state.active}
            textColor={textColor}
            inverseTextColor={inverseTextColor}>
            {showReduction && (
              <Reduction
                promotion={promotion}
                currency={currency}
                textColor={textColor}
                inverseTextColor={inverseTextColor}
                reductionClass={reductionClass}
              />
            )}
            {showPeriodicity && (
              <Periodicity
                promotion={promotion}
                textColor={textColor}
                inverseTextColor={inverseTextColor}
                reductionClass={reductionClass}
              />
            )}
            {!showReduction && !showPeriodicity && (
              <Icon iconName={promotion.get("icon")} iconBlack={inverseTextColor !== white} />
            )}
          </PromoGraphic>
          <div
            dangerouslySetInnerHTML={renderHTML(promotion.get("name"))}
            className={classnames("wbkv9-PromotionItem-title", styles.title)}
          />
        </InnerContainer>
        <Overlay
          show={this.state.show}
          onHide={() => this.setState({ show: false, active: false })}
          placement={this.state.placement}
          container={this}
          rootClose>
          {({ props }) => (
            <StatefulToolTip id={id} toolTipStyle={this.state.toolTipStyle} {...props}>
              <PromotionDescription
                promotion={promotion}
                mode={"tooltip"}
                styles={styles}
                inverseTextColor={inverseTextColor}
              />
            </StatefulToolTip>
          )}
        </Overlay>
      </div>
    );
  }
}

//TODO: Correct proptypes
// PromotionItem.propTypes = {
//   changeRemoved: PropTypes.func,
//   scrollTop: PropTypes.func,
//   toolTipOffset: PropTypes.number,
//   toolTipVerticalLimit: PropTypes.number,
//   promotion: PropTypes.object.isRequired,
//   currency: PropTypes.object.isRequired,
//   id: PropTypes.string.isRequired,
// };
